export default __webpack_public_path__ + "static/media/cost-graphic.264235b1.png";